import * as React from 'react';
import styled from "styled-components";
import fileBlank from "../../images/fileBlank.jpeg";
import whiteTrashBin from "../../images/whiteTrashBin.svg";
import {useEffect, useState} from "react";
import usePortalService from "../../services/PortalService";
import { Diploma } from "../../types";

const Card = styled.a`
  position: relative;
  color: black;
  border-radius: 0.25em;
  border: solid 1px darkgray;
  margin-right: 10px;
  margin-bottom: 10px;
  padding-bottom: 15%;
  aspect-ratio: 26/21;
  overflow: hidden;
  :focus {
    outline: none;
  }
`

const TrashBinContainer = styled.div`
  cursor: pointer;
  position: absolute;
  margin: auto;
  border-radius: 0.25em;
  opacity: 50%;
  background-color: black;
  padding: 4px;
  top: 4px;
  right: 4px;
  height: 24px;
  width : 24px;
`

const FileName = styled.div`
  display: flex;
  gap: 0;
  width : 163px;
  max-width: 100%;
  padding: 0.25em 8px 0 8px;
  .name {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  font-size: 10px;
  font-weight: 600;
  line-height: 14px;
  color: #45505A;
`

const FileSize = styled.p`
  font-size: 10px;
  font-weight: 400;
  line-height: 14px;
  padding: 0 8px 0.25em 8px;
  color: #45505A;
`

export const DeletableCertificate = ({diploma, deleteFromList} : {diploma: Diploma, deleteFromList: (id: string) => void}) => {
  const {getPdf} = usePortalService();

  console.log(diploma)

  const [name, setName] = useState<string | undefined>("");
  const [extension, setExtension] = useState("");
  const [size, setSize] = useState<string | undefined>("");

  useEffect(() => {
    setName(diploma.name);
    setSize(diploma.length);
    // (
    //   async () => {
    //     getFileName(diploma.src)
    //     await  getFileSize(diploma.src)
    //   }
    // )()
  },[])

  const handleClick = (e: React.MouseEvent<HTMLImageElement, MouseEvent>) => {
    e.preventDefault();
    getPdf(diploma.id).then((result) => {
      const fileUrl = URL.createObjectURL(result);
      window.open(fileUrl, "_blank");
    })
  }

  const getFileName = (url: string) => {
    const path = url.substring(url.lastIndexOf('/') + 1);
    const splittedByPoint = path.split('.');

    setName(splittedByPoint.slice(0,-1).join('.') + '.');
    setExtension(splittedByPoint[splittedByPoint.length - 1])
  }

  const getFileSize = async (url: string) => {
    let response;

    try {
      response = await fetch(url, {
        method : "HEAD"
      });
    } catch(e: any) {
      return e.toString();
    }

    const content_length = response.headers.get('Content-Length');
    /* setSize(Math.ceil(Number(content_length) / 1024)); */
  }

  return(
    <Card 
      key={diploma.id} 
      id={`card-${diploma.id}`} 
      target="_blank" 
      href={diploma.src}>
      <div 
        className="position-relative" 
        style={{backgroundColor : "lightgray"}}>
        <img 
          src={diploma.img ?? fileBlank}
          style={{aspectRatio : "137/105", objectFit : "cover", width:"163px"}}
          onClick={handleClick}
          />
        <TrashBinContainer 
          onClick={() => deleteFromList(diploma.id)}>
          <img src={whiteTrashBin} width="16px" style={{position : "absolute", top : "4px", left : "4px"}}/>
        </TrashBinContainer>
      </div>
      <div className="position-absolute bottom-0 bg-white"
        onClick={handleClick}>
        <FileName>
          <span className="name">{name}</span>
          <span>{extension}</span>
        </FileName>
        <FileSize>{size}</FileSize>
      </div>
    </Card>
  )
}